import { render } from "./fileDropperList.vue?vue&type=template&id=82bae6e2&ts=true"
import script from "./fileDropperList.vue?vue&type=script&lang=ts"
export * from "./fileDropperList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__